/* ZAutocomplete
Versione 1.2.4 - 08 Luglio 2025 - Massimiliano Zirilli
                 - FIX: La larghezza dell'input è al 100% sempre
Versione 1.2.3 - 3 Marzo 2024 - Mauro Brasile
                 - FIX: L'input non metteva stringa vuota quando il campo era uguale al valore di default 
Versione 1.2.2 - 21 Novembre 2023 - Massimiliano  Zirilli
                 - FIX: Migliorata gestione della tabulazione
                 - FIX: Inserita possibilità di selezionare l'assenza di voce
Versione 1.1.2 - 15 Giugno 2023 - Massimiliano  Zirilli
                 - FIX: Introdotto calcolo automatico wrapperId
Versione 1.1.1 - 16 Maggio 2023 - Massimiliano  Zirilli
                 - FIX: Introdotti messaggi di console per avviso problematiche
Versione 1.1.0 - 29 Marzo 2023 - Massimiliano  Zirilli
                 - NEW: Introdotta proprietà per la disabilitazione dell'autocomplete
Versione 1.0.0 - 06 Agosto 2022 - Massimiliano  Zirilli
                 - Prima versione partendo da un esempio su internet
*/

<template>
<div>
	<div :id="wrapperId" class="simple-typeahead">
		<input ref="inputRef"
         :id="inputId"
         :class="InputClasses"
         type="text"
         style="width:100%;"
         :placeholder="placeholder"
         :value="input"
         :disabled="disabled"
         @input="onInput"
         @focus="onFocus"
         @blur="onBlur"
         @keydown.down.prevent="onArrowDown"
         @keydown.up.prevent="onArrowUp"
         @keydown.enter.prevent="selectCurrentSelection"
         @keydown.tab="selectCurrentSelection"
         autocomplete="off"
         v-bind="$attrs"
		/>
		<div v-if="isListVisible" class="simple-typeahead-list">
			<div class="simple-typeahead-list-header" v-if="$slots['list-header']">
        <slot name="list-header"></slot>
   </div>
			<div class="simple-typeahead-list-item"
        :class="{ 'simple-typeahead-list-item-active': currentSelectionIndex == index }"
        v-for="(item, index) in filteredItems"
        :key="index"
        @mousedown.prevent
        @click="selectItem(item)"
        @mouseenter="currentSelectionIndex = index">
				   <span class="simple-typeahead-list-item-text" :data-text="GetCaptionItem(item)" 
            v-if="$slots['list-item-text']">
            <slot name="list-item-text" 
                  :item="item" 
                  :GetCaptionItem="GetCaptionItem" 
                  :boldMatchText="boldMatchText">
            </slot>
       </span>
				   <span class="simple-typeahead-list-item-text" 
             :data-text="GetCaptionItem(item)" 
             v-html="boldMatchText(GetCaptionItem(item))" 
             v-else>
       </span>
			</div>
			<div class="simple-typeahead-list-footer" 
        v-if="$slots['list-footer']">
        <slot name="list-footer"></slot>
   </div>
	 </div>
	</div>
</div> 
</template>

<script>
var Contatore = 0;

export default 
{
   emits: ['onInput', 'onFocus', 'onBlur', 'update:modelValue'],
	  inheritAttrs: false,
   name : 'Autocomplete',
   props: 
   { 
      modelValue       : {
                         },
      ValueNoSelection : {
                           type : Number,
                           default : -1
                         },
      InputClasses     : {
                           type : String 
                         },
      FieldDescrizione : {
                            type: String,
                            default : ''
                         },
      FieldChiave      : {
                            type: String,
                            default : ''
                         },
      InvalidValue     : {
                            default : '-1'
                         },
      id               : {
                          type: String,
                         },
      placeholder      : {
                          type: String,
                          default: '',
                         },
      items            : {
                          type: Array,
                          required: true,
                         },
      minInputLength   : {
                           type      : Number,
                           default   : 2,
                           validator: (prop) => 
                                      {
                                       return prop >= 0;
                                      },
                    	  	},
     disabled         : {
                          type : Boolean,
                          default : false
                        }
		},

		mounted() 
  {
			 if (this.modelValue !== undefined && this.modelValue !== null) 
				    this.selectItem(this.GetItemFromModelValue(this.modelValue));
		},

		data() 
  {
			return {
            inputId: this.id ? this.id : 'Autocomplete' + (Contatore++).toFixed(),
            input: '',
            isInputFocused: false,
            currentSelectionIndex: 0,
          };
		},

		methods: 
  {
     GetItemFromModelValue(ModelValue)
     {
       var StartModelValue = ModelValue;
       if(this.FieldChiave != '')
       {
         var Self = this;
         StartModelValue = this.items.find(function(AnElement)
         {
           return AnElement[Self.FieldChiave] == Self.modelValue;
         });
       }
       return StartModelValue;
     },

     GetCaptionItem(item)  
     {
       if(this.FieldDescrizione == '') 
          return item;
       else 
       {
         if(this.FieldDescrizione == undefined)
         {
           console.error('AUTOCOMPLETE: Non è presente ' + this.FieldDescrizione + ' nella voce seguente');
           console.error(item); 
         }
         return item != undefined ? item[this.FieldDescrizione] : '';
       }
     },

      onInput($event) 
     {
        if (this.isListVisible && this.currentSelectionIndex >= this.filteredItems.length) 
            this.currentSelectionIndex = (this.filteredItems.length || 1) - 1;
        this.input = $event.target.value;
        if(this.input == '')
           this.selectItem() 
        this.$emit('onInput', { input: this.input, items: this.filteredItems });
      },

      onFocus() 
     {
        this.isInputFocused = true;
        this.$emit('onFocus', { input: this.input, items: this.filteredItems });
     },

     onBlur() 
     {
        this.isInputFocused = false;
        this.$emit('onBlur', { input: this.input, items: this.filteredItems });
     },
     onArrowDown($event) 
     {
        if (this.isListVisible && this.currentSelectionIndex < this.filteredItems.length - 1) 
           this.currentSelectionIndex++;
        this.scrollSelectionIntoView();
			  },
     onArrowUp($event) 
     {
        if (this.isListVisible && this.currentSelectionIndex > 0) 
           this.currentSelectionIndex--;
        this.scrollSelectionIntoView();
     },
     scrollSelectionIntoView() 
     {
        setTimeout(function()
        {
           const list_node = document.querySelector(`#${this.wrapperId} .simple-typeahead-list`);
           const active_node = document.querySelector(`#${this.wrapperId} .simple-typeahead-list-item.simple-typeahead-list-item-active`);
           if(active_node != null)
              if (!(active_node.offsetTop >= list_node.scrollTop && active_node.offsetTop + active_node.offsetHeight < list_node.scrollTop + list_node.offsetHeight)) 
              {
                 let scroll_to = 0;
                 if (active_node.offsetTop > list_node.scrollTop) 
                    scroll_to = active_node.offsetTop + active_node.offsetHeight - list_node.offsetHeight;
                 else 
                 {
                    if (active_node.offsetTop < list_node.scrollTop) 
                       scroll_to = active_node.offsetTop;
                 }
                 list_node.scrollTo(0, scroll_to);
              }
        });
     },
     selectCurrentSelection() 
     {
        this.selectItem(this.currentSelection);
     },
     
     selectItem(item) 
     {
        if(item != undefined)
        {
          this.input = this.GetCaptionItem(item);
          this.currentSelectionIndex = 0;
          this.$refs.inputRef.blur();
          let NewValue = this.InvalidValue;
          if(this.FieldChiave != '')
          {
             if(item != undefined)
                NewValue = item[this.FieldChiave];
          }
          else NewValue = item;
          if(this.modelValue != NewValue)
          {
             this.$emit('update:modelValue',NewValue);
          }
        }
        else this.$emit('update:modelValue',this.ValueNoSelection);
     },
     escapeRegExp(string) 
     {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
     },
     boldMatchText(text) 
     {
        const regexp = new RegExp(`(${this.escapeRegExp(this.input)})`, 'ig');
        return text.replace(regexp, '<strong>$1</strong>');
     },
     clearInput() 
     {
        this.input = '';
     },
     getInput() 
     {
        return this.$refs.inputRef;
     },
     focusInput() 
     {
        this.$refs.inputRef.focus();
        this.onFocus();
     },
     blurInput() 
     {
        this.$refs.inputRef.blur();
        this.onBlur();
     },
		},
		computed: 
  {
     wrapperId() 
     {
      return `${this.inputId}_wrapper`;
     },
     filteredItems() 
     {
      const regexp = new RegExp(this.escapeRegExp(this.input), 'i');
      var Self = this;
      return this.items.filter(function(item) 
      { 
        let Caption = Self.GetCaptionItem(item);
        if(Caption == undefined)
        {
          console.error('AUTOCOMPLETE: Impossibile trovare la caption della voce ' + JSON.stringify(item));
          return false;
        }
        return Caption.match(regexp) 
      });
     },
     isListVisible() 
     {
      return this.isInputFocused && this.input.length >= this.minInputLength && this.filteredItems.length;
     },
     currentSelection() 
     {
      return this.isListVisible && this.currentSelectionIndex < this.filteredItems.length ? this.filteredItems[this.currentSelectionIndex] : undefined;
     },
		},
  watch :
  {
     modelValue :
     {
       handler(NewValue)
       {
         if(NewValue != undefined)
         {
            if(NewValue == this.InvalidValue)
               this.input = ''
            this.selectItem(this.GetItemFromModelValue(NewValue));
         }
       }
     }, 
  }
	};
 </script>

<style scoped>
</style>
